var $543d6d2a56ed7d8d$exports = {};
const $543d6d2a56ed7d8d$var$ENV = {
    MAIN_URL: "https://nomorepizzaparties.com",
    MAILTO_URL: "mailto:admin@nomorepizzaparties.com",
    NOCODB_DATA_HREF: "https://nocodb.nomorepizzaparties.com/dashboard/#/nc/view/e2884ee6-5141-4b3a-83f7-aca7913689be",
    NOCODB_SUBMIT_FORM_HREF: "https://nocodb.nomorepizzaparties.com/dashboard/#/nc/form/fe9c2368-ab41-4cf5-9ef0-162810399902",
    UMAMI_TRACKER_URL: "https://umami-ravd7j.umami.analytics.nimbusws.com/script.js",
    UMAMI_SITE_ID: "f399419f-95e4-4413-8997-9ee7a97c6511"
};
document.addEventListener("DOMContentLoaded", (ev)=>{
    // Replace variables that should be environment variables
    document.querySelectorAll("a[data-href-replace-env]").forEach((elem)=>{
        const key = elem.dataset.hrefReplaceEnv;
        if (key in $543d6d2a56ed7d8d$var$ENV) elem.href = $543d6d2a56ed7d8d$var$ENV[key];
    });
    const umamiTrackerURL = $543d6d2a56ed7d8d$var$ENV["UMAMI_TRACKER_URL"];
    const umamiSiteID = $543d6d2a56ed7d8d$var$ENV["UMAMI_SITE_ID"];
    if (!umamiTrackerURL || !umamiSiteID) return;
    // Add Umami script tag to the page
    const scriptElem = document.createElement("script");
    scriptElem.src = umamiTrackerURL;
    scriptElem.dataset["websiteId"] = umamiSiteID;
    document.body.appendChild(scriptElem);
});


//# sourceMappingURL=index.1774e8de.js.map
